import { LayoutGrid } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";
import { cn } from "@/lib/utils";

/**
 * The raised Switch Project control — PropPay's glassy button in SaleFish's
 * surface and SaleFish's 10px corners (Andrew, 2026-09-27).
 *
 * It is the one control in the menu that LEAVES the context rather than moving
 * within it, so it is drawn as a pressable object, not a list row. One
 * component because it appears in two panels — the sidebar (docked or as the
 * drawer) and the phone's More sheet — and two hand-kept copies are how they
 * drift apart. The recipe is `.glass-button` in index.css, with its dark twin.
 */
export function SwitchProjectButton({
  onClick,
  className,
  "data-testid": testId = "button-switch-project",
}: {
  onClick: () => void;
  className?: string;
  "data-testid"?: string;
}) {
  const t = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={cn(
        "glass-button group flex min-h-[52px] w-full items-center gap-2.5 rounded-full py-1.5 pl-1.5 pr-3 text-left text-body font-semibold",
        "transition-[box-shadow,transform,background] duration-instant ease-standard hover:-translate-y-px active:translate-y-0",
        "outline-hidden focus-visible:ring-2 focus-visible:ring-ring",
        className,
      )}
    >
      <span className="glass-button-well flex size-9 shrink-0 items-center justify-center rounded-full">
        <LayoutGrid className="size-[18px]" aria-hidden="true" />
      </span>
      {/* "Projects", not "Switch Project" (Andrew, 2026-09-29): the same word
          as the breadcrumb's grid glyph and the page it opens. */}
      <span className="flex-1 truncate">{t("projectsTitle", "Projects") || "Projects"}</span>
    </button>
  );
}
